<div class="container save-layer" *ngIf="esriLayer && userId">
    <div *ngIf="!isLoading">
        <h4>Layer Information</h4>
        <div class="field">
            Layer name:&nbsp;<input type="text" [(ngModel)]="name" placeholder="Enter layer name">
        </div>
        <div class="field">
            Description:&nbsp;<textarea placeholder="Enter layer description"
                                        [(ngModel)]="description"></textarea>
        </div>
        <div class="field">
            <span>Create a New Layer</span><input type="checkbox" [(ngModel)]="createNewLayer" [disabled]="disableCreateLayer" />
            <div>
                <em>When selected this will add a new layer to the layer catalog</em>
            </div>
        </div>
        <div *ngIf="enableFolders" class="field">
            <h4>Select Layers Folder</h4>
            <div>
                <span>New Folder:</span><input type="checkbox" value="false" (click)="isNewFolder()">
            </div>
            <div *ngIf="newFolder">
                New Folder Name:<input type="text" placeholder="Enter new folder name" [(ngModel)]="newFolder.name">
            </div>
            <div>
                <label>
                    Parent Folder:
                    <select class="modifier-class" [(ngModel)]="parentFolderId">
                        <option *ngFor="let option of parentFolders; trackBy:folderTrack" [ngValue]="option.id"
                                (click)="parentFolderSelected(value)">
                            {{ option.name }}
                        </option>
                    </select>
                </label>
            </div>
        </div>
        <div class="save-cancel">
            <button class="btn btn-clear right" (click)="closeWindow()">Cancel</button>
            <button class="btn right" (click)="saveLayer()">Save</button>
        </div>
    </div>
    <div *ngIf="isLoading">
        <div class="loader is-active padding-leader-3 padding-trailer-3">
            <div class="loader-bars"></div>
            <div class="loader-text">Loading...</div>
        </div>
    </div>
</div>
<div class="container" *ngIf="!userId">
    <span>Close this window and log in to save layers.</span>
</div>
